import type { SearchQuery } from '~/features/advanced-search/types';

import { withQueryFormat } from '~/redux/api/sylvanus/operations/searchScopeUtils';
import { sylvanus } from '~/services/serviceInstances';

const DOCUMENT_HANDLER_FILTER_ID = 'document_handler_id_Document';

type UploadDdeTableDocumentsRequest = {
  documentHandlerIds: string[];
  metadataFilters: string[];
  tableId: string;
};

type ServerUploadScope = {
  filters: string[];
  query: SearchQuery;
  store_as_recent_search: boolean;
};

type ServerUploadRequest = {
  data: {
    attributes: ServerUploadScope;
  };
  type: 'document';
};

const buildDocumentHandlerQuery = (documentHandlerIds: string[]): SearchQuery =>
  withQueryFormat([
    {
      type: 'filter',
      id: DOCUMENT_HANDLER_FILTER_ID,
      operator: 'contains_any',
      value: {
        value_list: documentHandlerIds,
        value_meta: {},
      },
    },
  ] as SearchQuery);

const mapRequest = ({
  documentHandlerIds,
  metadataFilters,
}: Pick<
  UploadDdeTableDocumentsRequest,
  'documentHandlerIds' | 'metadataFilters'
>): ServerUploadRequest => ({
  type: 'document',
  data: {
    attributes: {
      query: buildDocumentHandlerQuery(documentHandlerIds),
      filters: metadataFilters,
      store_as_recent_search: false,
    },
  },
});

export const uploadDdeTableDocuments = async ({
  documentHandlerIds,
  metadataFilters,
  tableId,
}: UploadDdeTableDocumentsRequest): Promise<void> => {
  await sylvanus.post(
    `/dde/table/${tableId}/upload`,
    mapRequest({ documentHandlerIds, metadataFilters }),
  );
};
